import { useQuery } from "react-query";
import { ESSAYS } from "../constants";
import { getEssaysList } from "./EssayService";

const useGetEssaysList = () => {
  return useQuery(ESSAYS, () => getEssaysList());
};

export default useGetEssaysList;
